import { render } from "./ShowReturnNoteC.vue?vue&type=template&id=d3971ac8&ts=true"
import script from "./ShowReturnNoteC.vue?vue&type=script&lang=ts"
export * from "./ShowReturnNoteC.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__